module.exports = __webpack_public_path__ + "img/404.9c7cc663.png";